import { MapGroupId } from "../../types";
import img from "../../mapImages/ShorelineMain3D.webp";

const mapData = {
  groupId: MapGroupId.Shoreline,
  groupName: {
    en: "Shoreline",
    ru: "Берег",
  },
  title: {
    en: "Main 3D",
    ru: "Главная 3D",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
